import React, { useState, useEffect } from 'react';
import { AuthContext } from './AuthContext';
import { jwtDecode } from 'jwt-decode';

export const AuthProvider = ({ children }) => {
  const [userInfo, setUserInfo] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setUserInfo(decoded);
      } catch (e) {
        console.error('Token inválido:', e);
      }
    }
  }, []);

  return (
    <AuthContext.Provider value={{ userInfo }}>
      {children}
    </AuthContext.Provider>
  );
};
